module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/ppelv3-c2eb8b6ab80d8691fd5df9a75e455afc.jpg";